import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs/Observable';
import { DatePipe } from '@angular/common';

import { environment } from '../../../../../environments/environment';
import { IsActive } from './../../../../model';
import { CheckType } from '../../../../../../node_modules/@angular/core/src/view';

@Injectable()
export class EcallCreateService {

  private urlPrefix: string = environment.appUrl;

  constructor(
    private http: HttpClient,
    private datePipe: DatePipe
  ) { }

  create(input): Observable<any> {
    const url = this.urlPrefix + 'e-calls';
    return this.http
      .post(url, {
        creationTime: input.creationTime,
        receivedTime: input.receivedTime,
        arrivedTime: input.arrivedTime,
        completedTime: input.completedTime,
        status: input.status,
        remarks: input.remarks,
        customerReport: input.customerReport,
        contactPerson: input.contactPerson,
        contactNumber: input.contactNumber,
        siteId: input.siteId,
        teamIds: input.teamIds,
        equipList: input.equipList,
        userAssignModels: input.userAssignModels
      }, { observe: 'response' })
      .map(
        res => {
          if (res.status === 201) {
            return res.body;
          } else {
            return Observable.throw(null);
          }
        }
      )
      .catch(
        err => {
          return Observable.throw(err);
        }
      );
  }

}



// WEBPACK FOOTER //
// /Users/adminuser/Documents/pentagon/pentagon-admin/src/app/views/home/ecall/ecall-create/ecall-create.service.ts